export default "__VITE_ASSET__By9NLCZ1__"